import { FC, useState } from 'react'
import cn from './index.module.css'
import SecondaryButton from '@pages/Admin/CourseSettings/components/SecondaryButton/SecondaryButton'
import PrimaryButton from '@pages/Admin/CourseSettings/components/PrimaryButton/PrimaryButton'
import SeniorSeminaristResponsibilitySelect from '@pages/Admin/AllUsers/modals/CreateColleague/components/SeniorSeminaristResponsibilitySelect/SeniorSeminaristResponsibilitySelect'
import { updateSupervisorResponsibilities } from '../../utils/api'
import { useAddAlert } from '@/hooks/useAddAlert'

interface IBody {
  user: IUser
  onDismiss: () => void
  onSuccess: (classes: number[], groups: number[]) => void
}

const Body: FC<IBody> = ({ user, onDismiss, onSuccess }) => {
  const addAlert = useAddAlert()
  const [loading, setLoading] = useState(false)
  const [responsibilities, setResponsibilities] = useState({
    classes_supervisor: user.classes_supervisor ?? [],
    groups_supervisor: user.groups_supervisor ?? [],
  })

  const onSave = async () => {
    setLoading(true)
    const res = await updateSupervisorResponsibilities(
      user.id,
      responsibilities,
    )
    if (res.status === 'success') {
      addAlert({
        title: 'Успех',
        text: 'Данные куратора обновлены',
      })
      onSuccess(
        responsibilities.classes_supervisor,
        responsibilities.groups_supervisor,
      )
    } else {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Попробуйте позже или обратитесь к администратору',
      })
    }
    setLoading(false)
  }

  return (
    <div className={cn.content}>
      <SeniorSeminaristResponsibilitySelect
        selectedClasses={responsibilities.classes_supervisor}
        selectedGroups={responsibilities.groups_supervisor}
        onChange={(classes, groups) =>
          setResponsibilities({
            classes_supervisor: classes,
            groups_supervisor: groups,
          })
        }
      />
      <div className={cn.actions}>
        <SecondaryButton onClick={onDismiss} disabled={loading}>
          Отмена
        </SecondaryButton>
        <PrimaryButton onClick={onSave} isLoading={loading}>
          Сохранить
        </PrimaryButton>
      </div>
    </div>
  )
}

export default Body
